export default __webpack_public_path__ + "static/media/trapezoid_right.2c3b415e.png";